<template>
     <div>
       <div class="upload-list" v-for="(item,ind) in uploadList" :key="ind">
          <template v-if="item.status === 'finished'">
            <template v-if="isPdf(item.url)">
              <img :src="getImage(item.url)">
              <div class="upload-list-cover">
                  <Icon type="ios-eye-outline" @click.native="handleView(item.url)"></Icon>
                  <Icon type="ios-trash-outline" @click.native="handleRemove(item)"></Icon>
              </div>
            </template>
            <template v-else>
              <Icon type="md-document" size="20"/> pdf
              <div class="upload-list-cover">
                <a :href="getPdf(item.url)" target="_blank"><Icon type="ios-eye-outline"></Icon></a>
                <Icon type="ios-trash-outline" @click.native="handleRemove(item)"></Icon>
              </div>
            </template>
          </template>
          <template v-else>
              <Progress v-if="item.showProgress" :percent="item.percentage" hide-info></Progress>
          </template>
      </div>
      <!-- {{defaultList}} -->
        <Upload
            ref="upload"
            :show-upload-list="false"
            :default-file-list="defaultList"
            :on-success="handleSuccess"
            :format="['jpg','jpeg','png','pdf']"
            :max-size="2048"
            :data="{file_type:'contract_file'}"
            :headers="uploadHeaders"
            :on-format-error="handleFormatError"
            :on-exceeded-size="handleMaxSize"
            :before-upload="handleBeforeUpload"
            type="drag"
            multiple
            :action="uploadPath"
            class="upload-item" style="width: 58px;display:inline-block">
             <div style="width: 58px;height:58px;line-height: 58px;">
                 <Icon type="ios-camera" size="20"></Icon>
             </div>
          </Upload>
          <Modal title="预览" v-model="visible" :footer-hide="true">
              <img :src="getImage(imgPath)" v-if="visible" style="width: 100%">
          </Modal>
      </div>
</template>

<script>
  // import {fetch} from '../fetch/api'

  export default {
    name: 'UploadComponent',
    components: {
      // ContractCom: resolve => { require(['../components/ContractComponent'], resolve) }
    },
    props: {
      multiple: {
        type: Boolean,
        default: false
      },
      uploading: {
        type: Boolean,
        default: false
      },
      fileList: {
        type: Array,
        default: function () {
          return []
        }
      },
      uploadPath: {
        type: String,
        default: '/api/contract/upload'
      },
      data: {
        type: Object
      }
    },
    data () {
      let token = localStorage.getItem('token')

      return {
        entry_info: '',
        token: token,
        visible: false,
        imgPath: '',
        uploadHeaders: {
          'Authorization': `Bearer ${token}`
        },
        uploadList: [],
        defaultList: []
      }
    },
    mounted () {
      this.uploadList = this.$refs.upload.fileList
      // this.$emit('update:uploadList', this.$refs.upload.fileList)
      if (this.fileList.length > 0) {
        for (var k in this.fileList) {
          this.uploadList.push({
            'url': this.fileList[k],
            'ourl': this.fileList[k],
            'name': '',
            'status': 'finished',
            'showProgress': false,
            'percentage': 100
          })
        }
      }
    },
    destroyed () {
    },
    methods: {
      getImage (path) {
        return path.indexOf('api/console/file') < 0 ? `/api/console/file?path=${path}&token=${this.token}` : path
      },
      getPdf (path) {
        return path.indexOf('api/console/pdf') < 0 ? `/api/console/pdf?path=${path}&token=${this.token}` : path
      },
      isPdf (path) {
        return path.indexOf('pdf') < 0
      },
      handleView (path) {
        this.imgPath = path
        this.visible = true
      },
      handleRemove (file) {
        const fileList = this.$refs.upload.fileList
        this.$refs.upload.fileList.splice(fileList.indexOf(file), 1)
        let tmpData = []
        for (let k in this.$refs.upload.fileList) {
          tmpData.push(this.$refs.upload.fileList[k].ourl)
        }
        this.$emit('input', tmpData)
      },
      handleSuccess (res, file) {
        file.url = this.getImage(res.file.file_path)
        file.ourl = res.file.file_path
        this.fileList.push(res.file.file_path)
        this.$emit('input', this.fileList)
        setTimeout(() => {
          this.$emit('update:uploading', false)
        }, 500)
      },
      handleFormatError (file) {
        this.$Notice.warning({
          title: 'The file format is incorrect',
          desc: 'File format of ' + file.name + ' is incorrect, please select jpg or png.'
        })
      },
      handleMaxSize (file) {
        this.$Notice.warning({
          title: 'Exceeding file size limit',
          desc: 'File  ' + file.name + ' is too large, no more than 2M.'
        })
      },
      handleBeforeUpload () {
        const check = this.uploadList.length < 5
        if (!check) {
          this.$Notice.warning({
            title: 'Up to five pictures can be uploaded.'
          })
        }
        this.$emit('update:uploading', true)
        return check
      }
    }
  }
</script>
<style>
  .upload-list{
    display: inline-block;
    width: 60px;
    height: 60px;
    text-align: center;
    line-height: 60px;
    border: 1px solid transparent;
    border-radius: 4px;
    overflow: hidden;
    background: #fff;
    position: relative;
    box-shadow: 0 1px 1px rgba(0,0,0,.2);
    margin-right: 4px;
  }
  .upload-list img{
    width: 100%;
    height: 100%;
  }
  .upload-list-cover{
    display: none;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0,0,0,.6);
  }
  .upload-list:hover .upload-list-cover{
      display: block;
  }
  .upload-list-cover i{
    color: #fff;
    font-size: 20px;
    cursor: pointer;
    margin: 0 2px;
  }
</style>
